import React from "react";
import { Facebook, Instagram, Linkedin, Mail, Phone, Youtube, X } from "lucide-react";
import * as Icon from "../assets/icons";

export const Footer: React.FC = () => {
  const iconClass =
    "text-black/75 hover:text-black *:hover:scale-[1.05] *:duration-300 *:size-5";

  return (
    <footer
      id="contact"
      className="w-full flex flex-col items-center justify-center border-t-2 border-[#1f4f13] bg-white text-black/90"
      style={{ boxShadow: "inset 0 1px 0 rgba(31,79,19,0.2)" }}
    >
      <div className="w-full pt-5 sm:pt-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-10 lg:px-14 flex flex-col gap-y-3 sm:gap-y-4 items-center">
          <div className="w-full flex flex-col gap-y-8 sm:gap-y-10 pb-3 sm:pb-5 sm:flex-row justify-between items-center">
            <div className="flex sm:flex-col flex-row justify-between sm:justify-start w-full sm:w-fit items-center gap-y-3">
              <Icon.Kapsul className="fill-black size-8" />
              <a
                href="https://www.konya.bel.tr/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex gap-x-2"
              >
                <Icon.Konya className="fill-black dark:fill-white size-8" />
                <Icon.Altay className="fill-black size-8" />
                <Icon.MyCity className="fill-black size-8" />
              </a>
            </div>

            <div className="flex flex-col items-center gap-y-0.5 text-sm">
              <a className="flex items-center gap-x-2 no-underline text-black/90" href="tel:+903322053981">
                <Phone className="size-4" /> +90 (332) 205 39 81
              </a>
              <a
                className="flex items-center gap-x-2 no-underline text-black/90"
                href="mailto:iletisim@kapsul.org.tr"
              >
                <Mail className="size-4" /> iletisim@kapsul.org.tr
              </a>
              <div className="w-full text-[20px] flex items-center justify-evenly pt-1.5">
                <a target="_blank" rel="noopener noreferrer" className={iconClass} href="https://www.instagram.com/kapsulteknoloji" aria-label="Instagram">
                  <Instagram />
                </a>
                <a target="_blank" rel="noopener noreferrer" className={iconClass} href="https://twitter.com/kapsulteknoloji" aria-label="X">
                  <X />
                </a>
                <a target="_blank" rel="noopener noreferrer" className={iconClass} href="https://www.linkedin.com/company/kapsul-teknoloji-platformu/" aria-label="LinkedIn">
                  <Linkedin />
                </a>
                <a target="_blank" rel="noopener noreferrer" className={iconClass} href="https://www.facebook.com/KapsulTeknoloji" aria-label="Facebook">
                  <Facebook />
                </a>
                <a target="_blank" rel="noopener noreferrer" className={iconClass} href="https://www.youtube.com/channel/UCyT6skpXh6W09oADZwHXvLg" aria-label="YouTube">
                  <Youtube />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h6 className="font-light text-[10px] text-center">
        © 2026 Kapsül Teknoloji Platformu. Tüm hakları saklıdır.
      </h6>
    </footer>
  );
};
